import React, { Component } from 'react';

// 组件
import {
  DataTable,
  Icon,
  Checkbox,
  FormLayout,
  TextField,
  Pagination,
  Button,
  Spinner,
  Tooltip,
  BlockStack,
  Popover,

} from '@shopify/polaris';
import AddKeywordsModal from "../../../../components/AddKeywordsModal"
import ImportKeywordsModal from "../../../../components/ImportKeywordsModal"
import DeleteModal from "../../../../components/DeleteModal"
import EmptyTableTip from "../../../../components/EmptyTableTip"
// 样式+图标
import {
  SearchMinor,
  MobilePlusMajor,
  ChevronDownMinor,

} from "@shopify/polaris-icons";
import KeywordsResearchDeleteIcon from '../../../../assets/KeywordsResearchDeleteIcon';
import KeywordsResearchConvertIcon from '../../../../assets/KeywordsResearchConvertIcon';
import KeywordsResearchAddRemarkSuccess from '../../../../assets/KeywordsResearchAddRemarkSuccess';

import FooterPageSelect from '../../../../components/FooterPageSelect';
import { connect } from "react-redux";
import '../index.css';

// 接口
import {
  reqGetKeywordsLibrary, reqHandleOwnKewords,
} from '../../../../api';
import ApplyKeywordList from "../../../../components/ApplyKeywordList";

import { store } from "../../../../redux/store";
//翻译包
import Language from '../../../../i18n/Language';
import { cloneDeep, debounce } from 'lodash';
const t = Language

let timerArr = [];

class MyKeywords extends Component {

  state = {
    myKeywordsRow: [],
    myKeywordsListLength: 0,

    loading: true,
    // 排序
    orderBy: '',
    sortIndex: 1,
    orderBydirection: 'descending', //当前排序值
    headingIndex: 3, //默认排序选项
    // 搜索停顿
    delay: 0,
    // 搜索内容
    searchValue: '',
    // 分页
    page: 1,
    total: 0,
    hasPrevious: false,
    hasNext: true,
    size: 10,
    // 是否显示空页面
    isEmpty: false,
    // 所选择的ID
    tableInputID: [],
    tableCheckChecked: [],

    ScoreStautsArr: [],

    table: [],
    //全选
    checked: false,
    //添加关键词弹窗开关
    openAddKeywordsStatus: false,
    addKeywordsStatus: false,
    //导入关键词弹窗开关
    openImportKeywordsStatus: false,
    //删除弹窗开关
    openDeleteStatus: false,
    //删除保存状态
    delSaveStatus: false,

    deleteArr: [],

    UrlInput: [],
    //解决删除后 全选按钮和下方多个checkbox不同步的问题
    delStatus: false,
    //解决添加URL后 全选按钮状态问题
    addUrlStatus: false,
    current_PageSize: 10, // 表格条数
    userServices: this.props.userServices,
    isShowApplyBox: false,
  };

  shouldComponentUpdate(nextProps) {
    if(nextProps.userServices !== this.props.userServices) {
      this.setState({
        userServices: nextProps.userServices
      })
    }
    return true;
  }
  
  changeCheckbox = (index, value) => {
    //升级服务开关 
    if (this.props.userServices.CompetitorKeywords === false) {
      this.props.show();
      return;
    }

    var tableCheckArray = this.state.tableCheckChecked;
    tableCheckArray[index] = !tableCheckArray[index];

    //判断选中的数量
    var SelectedQuantity = 0;
    for (var i = 0; i < tableCheckArray.length; i++) {
      if (tableCheckArray[i] === true) {
        SelectedQuantity += 1;
      }
    }
    var checked = false;
    if (SelectedQuantity === 0) {
      checked = false;
    } else {
      checked = true;
    }
    this.setState({
      tableCheckChecked: tableCheckArray,
      myKeywordsListLength: SelectedQuantity,
      checked,
    }, () => {
      this.updateKeywordsList()
    })
  }

  //点击刷新关键词信息
  RefreshKeywordsPosition = async (objs, index) => {
    //升级服务开关 
    if (this.props.userServices.CompetitorKeywords === false) {
      this.props.show();
      return;
    }

    let ScoreStautsArr = this.state.ScoreStautsArr
    ScoreStautsArr[index] = 0
    this.setState({
      ScoreStautsArr
    }, () => {
      this.updateKeywordsList()
    })
    const params = {
      type: 4,
      id: [objs.id]
    }
    const response = await reqHandleOwnKewords(params)
    if (response.code === "200") {
      this.props.toggleToast(response.msg, false);
      this.checkKeywordsSyncTimer();
    } else {
      // this.props.toggleToast(response.msg, true);
      let data = cloneDeep(this.state.table);
      data.forEach(item => {
        if(item.id === objs.id) {
          item['errorTip'] = response.msg;
        }
      })
      ScoreStautsArr[index] = 1
      this.setState({
        table: data,
        ScoreStautsArr
      }, () => {
        this.updateKeywordsList()
      })
    }
  }

  //选择
  handleChangeAllCheckbox = () => {
    //升级服务开关 
    if (this.props.userServices.CompetitorKeywords === false) {
      this.props.show();
      return;
    }
    var tableCheckArray = this.state.tableCheckChecked;
    if (!this.state.checked) {
      for (let i = 0; i < tableCheckArray.length; i++) {
        tableCheckArray[i] = true
        this.setState({
          myKeywordsListLength: tableCheckArray.length,
          tableCheckChecked: tableCheckArray,
          checked: true
        }, () => {
          this.updateKeywordsList()
        })
      }
    } else {
      for (let i = 0; i < tableCheckArray.length; i++) {
        tableCheckArray[i] = false
        this.setState({
          tableCheckChecked: tableCheckArray,
          checked: false
        }, () => {
          this.updateKeywordsList()
        })
      }
    }
  }

  // 搜索事件
  handleSearchChange = (val) => {
    this.setState({
      searchValue: val,
    }, () => {
      this.queryGetKeywordsLibrary();
    })
  }

  //清空搜索
  handleClearButtonClick = () => {
    this.setState({
      searchValue: ''
    }, () => {
      this.handleSearchChange(this.state.searchValue)
    });
  }

  //排序
  handleSort = async (headingIndex, direction) => {
    var order = '';
    if (direction === 'descending') {
      order = 'DESC';
    } else if (direction === 'ascending') {
      order = 'ASC';
    }
    var index;
    if (headingIndex === 2) {
      index = 1;
    } else if (headingIndex === 3) {
      index = 2;
    }
    this.setState({
      headingIndex: headingIndex,
      orderBydirection: direction,
      orderBy: order,
      sortIndex: index,
      loading: true,
    }, () => {
      this.getKeywordsLibrary('sort')
    })
  }

  //添加url
  AddUrlkeywords = async (objs, index) => {
    //升级服务开关 
    if (this.props.userServices.CompetitorKeywords === false) {
      this.props.show();
      return;
    }

    if(!Boolean(this.state.UrlInput[index])) {
      let data = cloneDeep(this.state.table);
      data.forEach(item => {
        if(item.id === objs.id) {
          item['errorTip'] = "The input field cannot be empty";
        }
      })

      this.setState({
        table: data
      }, () => {
        this.updateKeywordsList();
      })
    } else {
      let ScoreStautsArr = this.state.ScoreStautsArr
      ScoreStautsArr[index] = 0
      this.setState({
        ScoreStautsArr
      }, () => {
        this.updateKeywordsList()
      })
  
      const params = {
        type: 1,
        url: this.state.UrlInput[index],
        id: [objs['id']],
      }
      const response = await reqHandleOwnKewords(params)
      if (response.code === "200") {
        this.props.toggleToast(response.msg, false);
        this.setState({
          addUrlStatus: true
        })
        this.getKeywordsLibrary();
        this.checkKeywordsSyncTimer();
      } else {
        // this.props.toggleToast(response.msg, true);
        let data = cloneDeep(this.state.table);
        data.forEach(item => {
          if(item.id === objs.id) {
            item['errorTip'] = response.msg;
          }
        })
        ScoreStautsArr[index] = 1
        this.setState({
          table: data,
          ScoreStautsArr
        }, () => {
          this.updateKeywordsList()
        })
      }
    }

  }

  // 点击打开添加关键词弹窗
  openAddKeywordsModal = () => {
    //升级服务开关 
    if (this.props.userServices.CompetitorKeywords === false) {
      this.props.show();
      return;
    }

    this.setState({
      openAddKeywordsStatus: true
    })
  }

  // 添加关键词弹窗组件关闭 子组件传值到父组件
  AddKeywordsChildrenChange = async (val, keyword, link) => {//这个val就是子组件传来的
    // if (keyword === '') {
    //   this.props.toggleToast(t("Please enter keywords"), true);
    //   return
    // } else if (link === '') {
    //   this.props.toggleToast(t("Please enter your own link"), true);
    //   return
    // }

    this.setState({
      addKeywordsStatus: true
    })
    const params = {
      type: 2,
      url: link,
      keyword: keyword,
    }
    const response = await reqHandleOwnKewords(params)
    if (response.code === "200") {
      this.props.toggleToast(response.msg, false);
      this.setState({
        openAddKeywordsStatus: val,
        addKeywordsStatus: false
      })
      this.getKeywordsLibrary();
      this.checkKeywordsSyncTimer();
      return 200
    } else {
      this.setState({
        addKeywordsStatus: false
      })
      // this.props.toggleToast(response.msg, true);
      return response;
    }
  }

  //关闭关键词弹窗
  CloseKeywordsChildrenPop = (val) => {
    this.setState({
      openAddKeywordsStatus: val
    })
  }

  // 点击打开导入关键词弹窗
  openImportKeywordsModal = () => {
    //升级服务开关 
    if (this.props.userServices.CompetitorKeywords === false) {
      this.props.show();
      return;
    }
    this.setState({
      openImportKeywordsStatus: true
    })
  }

  // 导入关键词弹窗组件关闭 子组件传值到父组件
  ImportKeywordsChildrenChange = (val) => {//这个val就是子组件传来的
    this.setState({
      openImportKeywordsStatus: val
    })
  }

  // 点击打开删除弹窗
  openDeleteModal = (id) => {
    //升级服务开关 
    if (this.props.userServices.CompetitorKeywords === false) {
      this.props.show();
      return;
    }

    this.setState({
      openDeleteStatus: true,
      deleteArr: id,
    })
  }

  //关闭删除弹窗
  CloseDeletePop = (val) => {
    this.setState({
      openDeleteStatus: val,
      deleteArr: []
    })
  }

  // 删除弹窗组件关闭 子组件传值到父组件
  DeleteChildrenChange = (val, deleteArr) => {//这个val就是子组件传来的
    this.setState({
      delSaveStatus: true
    })
    this.DeletedKeywords(deleteArr).then(res => {
      this.setState({
        openDeleteStatus: val,
        delSaveStatus: false,
        delStatus: true, //删除请求成功后将状态改为true
      }, () => {
        this.getKeywordsLibrary()
      })
    })
  }

  //删除
  DeletedKeywords = async (IDArr) => {
    const params = {
      type: 3,
      id: IDArr
    }
    const response = await reqHandleOwnKewords(params)
    if (response.code === "200") {
      this.props.toggleToast(response.msg, false);
    } else {
      this.props.toggleToast(response.msg, true);
    }
  }

  ChangeAddUrlInput = (index, objs, val) => {
    var UrlInput = this.state.UrlInput;
    UrlInput[index] = val

    let data = cloneDeep(this.state.table);
    data.forEach(item => {
      if(item.id === objs['id']) {
        item['errorTip'] = '';
      }
    })

    this.setState({
      UrlInput,
      table: data,
    }, () => {
      this.updateKeywordsList();
    })
  }

  updateKeywordsList = () => {
    let { isShowApplyBox } = this.state;
    let myKeywordsList = this.state.table.map((item, index) => {
      let checkbox_content = <div style={{ paddingLeft: "8px" }}>
        <Checkbox
          checked={this.state.tableCheckChecked[index]}
          onChange={this.changeCheckbox.bind(this, index)}
        />
      </div>;
      let keyword = <div style={{ width: '15rem', gap: '.5rem' }} title={item.keyword}>
        <div style={{ width: '100%', textOverflow: 'ellipsis', overflow: 'hidden', fontSize: '14px' }}>{item.keyword}</div>
      </div>;
      let volume = item.volume;
      let kdColor = item.kd <= 40 ? 'ScoreItemGreen' : item.kd <= 70 ? 'ScoreItemOrange' : 'ScoreItemRed'
      let score = <div className='ScoreItem'>
        <span className={kdColor}>{item.kd}</span>
      </div>;
      let position = <div className='PositionItem'>
        <div>
          {item.position_history === 0 && item.position === 0 ? <span>{item.position}</span> :
            item.position_history === 0 && item.position > 0 ? 
            <div><span className='PositionItemRed'>↑{100 - item.position}</span><span>{item.position}</span></div> :
              item.position_history < item.position ?
                <div><span className='PositionItemGreen'>↓{item.position - item.position_history}</span><span>{item.position}</span></div> :
                <div><span className='PositionItemRed'>↑{item.position_history - item.position}</span><span>{item.position}</span></div>
          }
        </div>
        {this.state.ScoreStautsArr[index] ? <span onClick={this.RefreshKeywordsPosition.bind(this, item, index)} style={{ cursor: 'pointer' }}><Icon source={KeywordsResearchConvertIcon} /></span> : <span><Spinner size="small" /></span>}
      </div>;
      let url = <div>
        {item.url ? <Tooltip content={item.url}>
          <div className='' style={{ width: '15rem', display: 'flex', flexWrap: 'wrap' }}>
            <div style={{ width: '100%', textOverflow: 'ellipsis', overflow: 'hidden', fontSize: '13px' }}>{item.url}</div>
            <div style={{ width: '100%', textOverflow: 'ellipsis', overflow: 'hidden', color: '#1558D6', fontSize: '16px' }}>{item.title_tag}</div>
            <div className='urlDesc'>{item.meta_description}</div>
          </div>
        </Tooltip> :
          <div style={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
            <div style={{width: '25rem'}}>
              <Popover
                active={isShowApplyBox === item.id}
                activator={<TextField 
                    value={this.state.UrlInput[index]} 
                    onChange={this.ChangeAddUrlInput.bind(this, index, item)} 
                    autoComplete="off" 
                    placeholder={t("Please enter your own website")}
                    error={item['errorTip']}
                    suffix={<span 
                      className="chevronApply"
                      onClick={() => this.setApplyShowState(item)}
                    >
                      <Icon source={ChevronDownMinor} />
                    </span>}
                  ></TextField>
                }
                onClose={this.closeApplyBox}
              >
                <ApplyKeywordList 
                  mode="single"
                  changeSelectApply={(data) => this.changeSelectApply(data, index)}
                />
              </Popover>
            </div>
            {this.state.ScoreStautsArr[index] ? <span style={{ cursor: "pointer" }} onClick={this.AddUrlkeywords.bind(this, item, index)}><Icon source={KeywordsResearchAddRemarkSuccess}></Icon></span> : <span><Spinner size="small" /></span>}
          </div>}
      </div>;
      let del = <span className='DeleteIcon' onClick={this.openDeleteModal.bind(this, [item.id])} style={{ cursor: 'pointer' }}><Icon source={KeywordsResearchDeleteIcon} /></span>;
      return ([
        checkbox_content,
        keyword,
        volume,
        score,
        position,
        url,
        del,
      ]);
    });
    // 空页面判断
    if (myKeywordsList.length > 0) {
      this.setState({
        myKeywordsRow: myKeywordsList,
        isEmpty: false
      })
    } else {
      this.setState({
        myKeywordsRow: myKeywordsList,
        isEmpty: true
      })
    }
  }

  // 设置弹窗
  setApplyShowState = (data) => {
    this.setState({
      isShowApplyBox: data.id,
    }, () => {
      this.updateKeywordsList();
    })
  }

  //获取关键词库列表
  getKeywordsLibrary = async (sort = '') => {
    let ScoreStautsArr = [];
    const params = {
      type: 2,
      page: this.state.page,
      size: this.state.size,
      sortType: this.state.orderBy,
      sortIndex: this.state.orderBy !== '' ? this.state.sortIndex : '',
      q: this.state.searchValue ? this.state.searchValue : '',
    };
    const res = await reqGetKeywordsLibrary(params);
    if (res.code === "200") {
      var tableInputCheckedArr = [];
      //表格ID
      var tableInputIDArr = [];
      var UrlInput = [];
      for (let i = 0; i < res.data.length; i++) {
        tableInputCheckedArr.push(false)
        ScoreStautsArr.push(res.data[i].status);
        tableInputIDArr.push(res.data[i].id);
        UrlInput.push('');
      }
      // 更新分页数据
      const maxPage = Math.ceil(res.count / this.state.size);
      var hasPrevious = ""
      var hasNext = ""
      //如果当前页面大于1 且 小于 总分页   上下都为开启
      if (this.state.page > 1 && this.state.page < maxPage) {
        hasPrevious = true;
        hasNext = true;
        //如果当前页面小于等于1 且 小于总分页 下关闭 上开启
      } else if (this.state.page <= 1 && this.state.page < maxPage) {
        hasPrevious = false;
        hasNext = true;
        //如果当前页面大于1 且 大于等于 总分页   下开启 上关闭
      } else if (this.state.page > 1 && this.state.page >= maxPage) {
        hasPrevious = true;
        hasNext = false;
        // 否则都关闭
      } else if (this.state.page <= 1 && this.state.page >= maxPage) {
        hasPrevious = false;
        hasNext = false;
      }

      let data = cloneDeep(res.data);
      data.forEach(item => {
        item['errorTip'] = '';
      })

      this.setState({
        table: data,
        loading: false,
        total: res.count, //总关键词条数
        hasPrevious: hasPrevious,
        hasNext: hasNext,
        tableCheckChecked: tableInputCheckedArr,
        tableInputID: tableInputIDArr,
        UrlInput: UrlInput,
        ScoreStautsArr
      }, () => {
        this.updateKeywordsList()
      })

      //删除成功后 将checked置false
      if(this.state.delStatus) {
        this.setState({
          checked: false,
        })
      }

      //添加url成功后 将checked置false
      if(this.state.addUrlStatus) {
        this.setState({
          checked: false,
        })
      }

      if (ScoreStautsArr.indexOf(0) === -1) {
        return 200
      }
    }

    return ScoreStautsArr.indexOf(0) === -1 ? 200 : 0
  }

  //查询
  queryGetKeywordsLibrary = debounce( async (sort = '') => {
    if(sort === 'sort'){

    }else{
      this.setState({
        loading: true,
        page: 1
      });
    }
    const params = {
      type: 2,
      page: this.state.page,
      q: this.state.searchValue ? this.state.searchValue : '',
    };
    const res = await reqGetKeywordsLibrary(params);
    if (res.code === "200") {
      // 更新分页数据
      const maxPage = Math.ceil(res.count / this.state.size);
      var hasPrevious = ""
      var hasNext = ""
      //如果当前页面大于1 且 小于 总分页   上下都为开启
      if (this.state.page > 1 && this.state.page < maxPage) {
        hasPrevious = true;
        hasNext = true;
        //如果当前页面小于等于1 且 小于总分页 下关闭 上开启
      } else if (this.state.page <= 1 && this.state.page < maxPage) {
        hasPrevious = false;
        hasNext = true;
        //如果当前页面大于1 且 大于等于 总分页   下开启 上关闭
      } else if (this.state.page > 1 && this.state.page >= maxPage) {
        hasPrevious = true;
        hasNext = false;
        // 否则都关闭
      } else if (this.state.page <= 1 && this.state.page >= maxPage) {
        hasPrevious = false;
        hasNext = false;
      }

      this.setState({
        table: res.data,
        loading: false,
        total: res.count, //总关键词条数
        hasPrevious: hasPrevious,
        hasNext: hasNext,
      }, () => {
        this.updateKeywordsList()
      })
    }
  }, 500)

  //定时更新数据
  TimeoutGetKeywordsLibrary = async (sort = '') => {
    let ScoreStautsArr = [];
    const params = {
      type: 2,
      page: this.state.page,
      sortType: this.state.orderBy,
      sortIndex: this.state.orderBy !== '' ? this.state.sortIndex : '',
      q: this.state.searchValue ? this.state.searchValue : '',
    };

    const res = await reqGetKeywordsLibrary(params);
    if (res.code === "200") {
      for (let i = 0; i < res.data.length; i++) {
        ScoreStautsArr.push(res.data[i].status);
      }

      this.setState({
        table: res.data,
        ScoreStautsArr
      }, () => {

        this.updateKeywordsList()

      })

      if (ScoreStautsArr.indexOf(0) === -1) {
        return 200
      }
    }

    return ScoreStautsArr.indexOf(0) === -1 ? 200 : 0
  }

  //批量删除
  batchDeleteModal = (tableCheckChecked, tableInputID) => {
    var deleteArr = []
    for (let i = 0; i < tableCheckChecked.length; i++) {
      if (tableCheckChecked[i] === true) {
        deleteArr.push(tableInputID[i])
      }
    }
    this.openDeleteModal(deleteArr)
  }

  componentDidMount() {
    this.getKeywordsLibrary().then((res) => {
      if (res !== 200) {
        this.checkKeywordsSyncTimer()
      }
      this.props.loadingStatus();
    })
  }

  componentWillUnmount() {
    timerArr.map( timer =>{
      clearInterval(timer);
      timerArr.pop();
      return false;
    })
    this.setState = () => false;
  }

  // 检测关键词定时器
  checkKeywordsSyncTimer() {
    var timer = setInterval(function () {
      this.TimeoutGetKeywordsLibrary().then(function (response) {
        if (response === 200) {
          clearInterval(timer);
        }
      })
    }.bind(this), 5000);
    timerArr.push(timer);
  }

  // 关键词超过200长度提示
  exceedLengthsTip = () => {
    this.props.toggleToast('The maximum length is 200', true);
  }

  // 选择表格条数
  changePageSize = (e) => {
    this.setState({
        page: 1,
        size: Number(e),
        current_PageSize: Number(e),
        loading: true,
    }, () => {
      this.getKeywordsLibrary()
    })
  }

  // 关闭申请弹窗
  closeApplyBox = () => {
    this.setState({ isShowApplyBox: false }, () => {
      this.updateKeywordsList();
    })
  }

  // 选中数据
  changeSelectApply = (data, index) => {
    let newUrl = this.state.UrlInput;
    let compares = {
      "Products": "products",
      "Homepage": "",
      "Collections": "collections",
      "Blogs": "blogs",
      "Other Pages": "pages",
    }
    newUrl[index] = data[0] === "Homepage" ? `https://${store.getState().public.domain}` : 
          data[0] === "Blogs" ? `https://${store.getState().public.domain}/${compares[data[0]]}/${data[1].blog_handle}/${data[1].handle}` : `https://${store.getState().public.domain}/${compares[data[0]]}/${data[1].handle}`;

    this.setState({
      isShowApplyBox: false,
      UrlInput: newUrl,
    }, () => {
      this.updateKeywordsList();
    })
  }

  render() {
    const {
      state: {
        checked,
        myKeywordsRow,
        myKeywordsListLength,
        loading,
        orderBydirection,
        headingIndex,
        searchValue,
        isEmpty,
        page,
        total,
        size,
        hasPrevious,
        hasNext,
        tableCheckChecked,
        tableInputID,
        openAddKeywordsStatus,
        openImportKeywordsStatus,
        openDeleteStatus,
        deleteArr,
        delSaveStatus,
        addKeywordsStatus,
        current_PageSize,
        
      },
      getKeywordsLibrary,
      handleChangeAllCheckbox,
      handleSort,
      handleSearchChange,
      batchDeleteModal,
      openAddKeywordsModal,
      AddKeywordsChildrenChange,
      CloseKeywordsChildrenPop,
      openImportKeywordsModal,
      ImportKeywordsChildrenChange,
      DeleteChildrenChange,
      CloseDeletePop,
      handleClearButtonClick,
      exceedLengthsTip,
      changePageSize
    } = this;

    var showEmpty = "";
    if (total === 0) {
      if (searchValue) {
        showEmpty = <EmptyTableTip content={t("Nothing fits into the category")} overview={t("Please check elsewhere.")} mixheight={"400"} />
      } else {
        showEmpty = <EmptyTableTip content={t("No keywords be added now")} overview={t("please go to add your own keywords.")} mixheight={"400"} />
      }
    }

    let headings = [
      isEmpty ? <div style={{ paddingLeft: "8px" }}>
        <Checkbox
          label=""
          disabled
          checked={checked}
          onChange={handleChangeAllCheckbox}
        />
      </div> : <div style={{ paddingLeft: "8px" }}>
        <Checkbox
          label=""
          checked={checked}
          onChange={handleChangeAllCheckbox}
        />
      </div>,
      t("Keyword"),
      <Tooltip content={t("An estimation of the number of searches for a keyword over the latest month.")}>
        <span className="TitleHover" style={{cursor: 'default'}}>{t("Volume")}</span>
      </Tooltip>,
      <Tooltip content={t("Keyword Difficulty gives an estimation of how hard it is to rank in the top 10 organic search results for a keyword on a 100-point scale.")}>
        <span className="TitleHover" style={{cursor: 'default'}}>{t("KD")}</span>
      </Tooltip>,
      <Tooltip content={t("Shows the ranking of the website you added when customers search for this keyword on Google. 1. Only display the top 100 data. 2. The ranking requires you to manually click to update. 3. Numbers: last ranking, current ranking. More useful and efficient, AI features can help you quickly generate/optimize content that complies with SEO rules")}>
        <span className="TitleHover" style={{cursor: 'default'}}>{t("Position")}</span>
      </Tooltip>,
      t("URL/Search results"),
      t("Delete"),
    ]

    var selectAllDataButton = "";
    var SelectedQuantityText = "";

    selectAllDataButton = <Button onClick={() => { batchDeleteModal(tableCheckChecked, tableInputID) }}>{t("Delete")}</Button>;

    SelectedQuantityText = myKeywordsListLength +" " + t("selected");

    var sortableData = [false, false, true, true, false, false]

    if (checked) {
      sortableData = [false, false, false, false, false, false]
      headings = [
        <div className="headings_div1">
          <div className="headings_div2">
            <div className="Polaris-ResourceList-BulkActions__ButtonGroup">
              <div className="Polaris-ResourceList-CheckableButton Polaris-ResourceList-CheckableButton__CheckableButton--selectMode Polaris-ResourceList-CheckableButton__CheckableButton--selected">
                <div className="headings_div3">
                  <Checkbox
                    checked={checked}
                    onChange={handleChangeAllCheckbox}
                  />
                </div>
                <span className="Polaris-ResourceList-CheckableButton__Label">
                  {SelectedQuantityText}
                </span>
              </div>
              {selectAllDataButton}
            </div>
          </div>
        </div>,
        "",
        "",
        "",
        "",
        "",
        "",
      ];
    }

    const wwidth = this.props.public.window_width; // 屏幕宽度
    var footerContentMsg = "";
    if (total > 0) {
      const startNum = (page - 1) * size + 1;
      const endNum = page * size > total ? total : page * size;
      // footerContentMsg = t("Showing {{v1}} - {{v2}} of {{v3}} results", startNum, endNum, total);
      footerContentMsg = wwidth >= 550 ? <FooterPageSelect changePageSize={changePageSize} startNum={startNum} endNum={endNum} total={total} current_PageSize={current_PageSize} /> : t("Showing {{v1}} - {{v2}} of {{v3}} results", startNum, endNum, this.state.total);

    }

    const tableLoading = loading ? (
      <div className="DetailReport_Empty_New_div_margin_600">
        <Spinner size="large" color="teal" />
      </div>
    ) : (
      isEmpty ? <>
        <DataTable
          columnContentTypes={[
            "text",
            "text",
            "numeric",
            "numeric",
            "numeric",
            "text",
            "text",
          ]}
          headings={headings}
          rows={myKeywordsRow}
          sortable={[false, false, false, false, false, false]} // 需要排序把false 改成true [false, false, true, true, false, false]
          defaultSortDirection={orderBydirection} //ascending descending none
          initialSortColumnIndex={headingIndex}
          onSort={handleSort}
          verticalAlign="middle"
        />
        {showEmpty}
        <div className="Polaris-DataTable__Footer_right">
          <Pagination
            label={footerContentMsg}
            hasPrevious={hasPrevious}
            onPrevious={() => {
              this.setState(({
                page: page - 1,
                checked: false,
                tableCheckChecked: [],
                loading: true
              }), () => {
                //重新请求列表
                getKeywordsLibrary();
              });
            }}
            hasNext={hasNext}
            onNext={() => {
              this.setState(({
                page: page + 1,
                checked: false,
                tableCheckChecked: [],
                loading: true
              }), () => {
                //重新请求列表
                getKeywordsLibrary();
              });
            }}
          />
          <div className="Polaris-DataTable__Footer_right_button">
            <Button onClick={() => { openAddKeywordsModal() }}><Icon source={MobilePlusMajor} />{t("Add keyword")}</Button>
            <Button onClick={() => { openImportKeywordsModal() }}>{t("Import")}</Button>
          </div>
        </div>
      </> : <>
        <DataTable
          columnContentTypes={[
            "text",
            "text",
            "numeric",
            "numeric",
            "numeric",
            "text",
            "text",
          ]}
          headings={headings}
          rows={myKeywordsRow}
          sortable={sortableData} // 需要排序把false 改成true [false, false, true, true, false, false]
          defaultSortDirection={orderBydirection} //ascending descending none
          initialSortColumnIndex={headingIndex}
          onSort={handleSort}
          verticalAlign="middle"
        />
        {/* <div className="Polaris-DataTable__Footer">
          {footerContentMsg}
        </div> */}
        <div className={`justify_center ${current_PageSize > 5 && myKeywordsRow.length > 5 ? 'sticky_footer' : ''}`}>
          <Pagination
            label={footerContentMsg}
            hasPrevious={hasPrevious}
            onPrevious={() => {
              this.setState(({
                page: page - 1,
                checked: false,
                tableCheckChecked: [],
                loading: true
              }), () => {
                //重新请求列表
                getKeywordsLibrary();
              });
            }}
            hasNext={hasNext}
            onNext={() => {
              this.setState(({
                page: page + 1,
                checked: false,
                tableCheckChecked: [],
                loading: true
              }), () => {
                //重新请求列表
                getKeywordsLibrary();
              });
            }}
          />
          <div className="Polaris-DataTable__Footer_right_button">
            <Button onClick={() => { openAddKeywordsModal() }}><Icon source={MobilePlusMajor} />{t("Add keyword")}</Button>
            <Button onClick={() => { openImportKeywordsModal() }}>{t("Import")}</Button>
          </div>
        </div>
      </>
    );

    const pageContent = <div className='DataTable'>
      <BlockStack gap={400}>
          <FormLayout>
            <TextField
              value={searchValue}
              onChange={handleSearchChange}
              placeholder={t("search keyword")}
              prefix={<Icon source={SearchMinor} />}
              clearButton
              onClearButtonClick={handleClearButtonClick}
            />
          </FormLayout>
        {tableLoading}
      </BlockStack>
      <AddKeywordsModal
        open={openAddKeywordsStatus}
        addKeywordsStatus={addKeywordsStatus}
        changeData={AddKeywordsChildrenChange}
        CloseDeletePop={CloseKeywordsChildrenPop}
        exceedLengths={exceedLengthsTip}
      />
      <ImportKeywordsModal
        open={openImportKeywordsStatus}
        changeData={ImportKeywordsChildrenChange}
      />
      <DeleteModal
        open={openDeleteStatus}
        delSaveStatus={delSaveStatus}
        deleteArr={deleteArr}
        CloseDeletePop={CloseDeletePop}
        changeData={DeleteChildrenChange}
      />
    </div>

    return (
      pageContent
    );
  }
}


const mapStateToProps = state => {
  return state
}

MyKeywords = connect(
  mapStateToProps,
)(MyKeywords);

export default MyKeywords;